export default function get(name, base64Encoded) {
    if (base64Encoded === void 0) { base64Encoded = false; }
    var cookieName = name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var _i = 0, ca_1 = ca; _i < ca_1.length; _i++) {
        var c = ca_1[_i];
        while (c.charAt(0) === " ")
            c = c.substring(1);
        if (c.indexOf(cookieName) === 0) {
            var value = c.substring(cookieName.length, c.length);
            if (base64Encoded)
                value = atob(value);
            return value;
        }
    }
    return null;
}
